import { ApiResponse } from 'apisauce';

import { Api } from './api';
import { getGeneralApiProblem, TranslationsResult, Translations } from '../models';

/**
 * Manages all requests to get Config Data from API.
 */
export class ConfigApi extends Api {
  async getTranslations(langCode: string): Promise<TranslationsResult> {
    // make the api call
    const response: ApiResponse<Translations> = await Api.apisauce.get(`/translations/${langCode}`);

    // the typical ways to die when calling an api
    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    // transform the data into the format we are expecting
    try {
      if (response.data) {
        return { kind: 'ok', data: response.data };
      }
      return { kind: 'bad-data' };
    } catch {
      return { kind: 'bad-data' };
    }
  }
}
